import { Link } from 'react-router-dom';
import Icon from '../components/Icons';

// Modules with a printable document at /documents/:bookingId (see DocumentPage).
const labels = {
  flights: 'Download e-ticket',
  hotels: 'Download voucher',
  bus: 'Download e-ticket',
  sightseeing: 'Download voucher',
  insurance: 'Download policy',
  packages: 'Download voucher',
  transfers: 'Download voucher',
};

/** Opens the booking's e-ticket or voucher in a new tab; other modules print the page as before. */
export default function DocumentLink({ booking, fallbackLabel }) {
  const label = labels[booking.module];
  if (!label) {
    return (
      <button type="button" className="btn btn-outline block" onClick={() => window.print()}>
        <Icon name="file" size={16} /> {fallbackLabel}
      </button>
    );
  }
  return (
    <Link to={`/documents/${booking.id}`} target="_blank" rel="noopener" className="btn btn-outline block">
      <Icon name="file" size={16} /> {label}
    </Link>
  );
}
